<template>
    <div>
        <Loading :value="loading"></Loading>
        <v-dialog
                v-model="dialogAjoutBudget"
                width="80%"
                :persistent="true"
                transition="dialog-bottom-transition"
                scrollable
        >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Planifier budget pour les travaux {{typeTrx.libelle}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form
                            id="formBudget"
                            :model="formBudget"
                            :rules="rulesBudget"
                            ref="formBudget"
                            :label-position="labelPosition"
                            class="demo-form-inline"
                    >
                        <v-layout wrap>
                            <v-flex xs12>
                                  <v-layout row>                       
                                    <v-flex md3 class="mr-1">
                                        <el-form-item prop="libelle" label="Liste " required style="width:100%">
                                            <el-select   filterable  allow-create  default-first-option  v-model="formBudget.libelle" placeholder="Selectionnez une tache de la liste" style="width:100%">
                                                <el-option-group
                                                        v-for="group in listeProduitBudget"
                                                        :key="group.label"
                                                        :label="group.label">
                                                    <el-option
                                                            v-for="(item,index) in group.produits"
                                                            :key="index"
                                                            :label="item.label"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-option-group>
                                            </el-select>
                                        </el-form-item>
                                    </v-flex>
      
                                </v-layout>
                                <v-layout row>
                                    <v-flex md3 class="mr-1">
                                        <el-form-item prop="dateMoisAn" label="Mois annee" required style="width:100%">
                                            <el-date-picker
                                                    format="MMMM-yyyy"
                                                    value-format="yyyy-MM"
                                                    v-model="formBudget.dateMoisAn"
                                                    type="month" id="dateMoisAn"
                                                    placeholder="Sélectionnez un mois"
                                                    style="width:100%">
                                            </el-date-picker>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md3 class="mr-1">
                                        <el-form-item prop="libelle" label="Liste " required style="width:100%">
                                            <el-select   filterable  allow-create  default-first-option  v-model="formBudget.libelle" placeholder="Selectionnez un élement de la liste" style="width:100%">
                                                <el-option-group
                                                        v-for="group in listeProduitBudget"
                                                        :key="group.label"
                                                        :label="group.label">
                                                    <el-option
                                                            v-for="(item,index) in group.produits"
                                                            :key="index"
                                                            :label="item.label"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-option-group>
                                            </el-select>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md3>
                                        <el-form-item prop="montant"  label="Montant " required style="width:100%">
                                            <el-input-number controls-position="right" v-model="formBudget.montant"  :min="0" ></el-input-number>
                                        </el-form-item>
                                    </v-flex>

                                    <v-flex md2>
                                        <el-form-item label="action" style="width:100%">
                                            <el-button type="primary" :disabled="!verifFormBudget"  @click="addListBudget(formBudget)">Ajouter</el-button>
                                        </el-form-item>
                                    </v-flex>


                                </v-layout>

                                <v-layout row>
                                    <v-flex xs12>
                                        <el-table :data="tableBudget" style="width: 100%">
                                            <el-table-column prop="dateMoisAn" label="Annee mois"> </el-table-column>
                                            <el-table-column prop="libelle" label="Libelle" sortable> </el-table-column>
                                            <el-table-column prop="montant" label="Montant proposé">
                                                <template slot-scope="scope">
                                                    {{new Intl.NumberFormat().format(scope.row.montant)}}
                                                </template>
                                            </el-table-column>


                                            <el-table-column label="Operations">
                                                <template slot-scope="scope">
                                                    <v-tooltip top>
                                                        <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableBudget)" dark>
                                                            <v-icon center>delete</v-icon>
                                                        </v-btn>
                                                        Supprimer
                                                    </v-tooltip>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </v-flex>
                                </v-layout>


                            </v-flex>
                        </v-layout>
                    </el-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="closeDialog()">Annuler</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="createBudget()">Enregistrer</v-btn>
                </v-card-actions>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    //function de difference de date

    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/bar");
    require("echarts/lib/chart/pictorialBar");
    require("echarts/lib/chart/funnel");
    require("echarts/lib/chart/sankey");
    require("echarts/lib/chart/scatter");
    require("echarts/lib/component/tooltip");
    require("echarts/lib/component/title");
    import html2canvas from "html2canvas";
    import Loading from "@/components/Loading";

    export default {
        components: {
            Loading
        },
        props:{
            show:{
                type: Boolean
            },
            typeTrx:{
                type: Object
            },
            idProjet: {
                type: Number
            }

        },
        name: "AjoutPrevisionBudget",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,

                //VARIABLE
                dialogAjoutBudget: false,
                formBudget:{
                    dateMoisAn: null,
                    libelle: "",
                    montant: 5
                },
                rulesBudget:{
                    dateMoisAn: [{ required: true, message: "Veuillez selectionner" }],
                    libelle: [{ required: true, message: "Veuillez selectionner" }],
                    montant: [{ required: true, message: "Veuillez saisir" }]
                },
                datePickerRtp:{
                },
                listeProduitBudget:[],
                tableBudget:[],
                labelPosition: 'top'


            };
        },
        computed: {
            verifFormBudget: function(){
                if(this.formBudget.dateMoisAn != null && this.formBudget.libelle != "" && this.formBudget.montant != ""  ){
                    return true;
                }
                else{
                    return false;
                }

            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true){
                    let _this = this;
                    this.tableBudget.splice(0)
                    let detailBudget = this.typeTrx.detailBudget
                    detailBudget.forEach((item)=>{
                        _this.tableBudget.push(item)
                    })
                   this.dialogAjoutBudget = true;

                   this.loadProduitBudget();
                    this.formBudget = {
                        libelle: "",
                        montant: 5
                    }

                }else{
                    this.dialogAjoutBudget = false;
                }
            }
        },
        methods: {
            resetForm(){
                this.$refs["formBudget"].resetFields();
            },

            deleteRow(index, rows) {
                rows.splice(index, 1);
            },

            //budget
            loadProduitBudget()
            {
                this.loading = true;
                let url = this.domaine + "budgetProjet/liste";

                this.listeProduitBudget.splice(0);
                this.$http.get(url).then(
                    response => {
                        if (response.body) {
                            this.loading = false;
                            this.listeProduitBudget = response.body.produits;
                        }
                    },
                    response => {
                        this.loading = false;
                    }
                );
            },

            addListBudget(item){
                //verifier si l'item n'et pas deja enregistrer dans le tableau
                let eltProd =  this.tableBudget.find(elt => elt.libelle == item.libelle && elt.dateMoisAn  == item.dateMoisAn  );
                if(eltProd != null){
                    this.$message.error(
                        "Cet element a déjà été ajouté à la liste"
                    );
                    return;
                }

                this.tableBudget.push({
                    libelle: item.libelle,
                    montant: item.montant,
                    dateMoisAn: item.dateMoisAn
                })

                this.formBudget = {
                        libelle: "",
                        montant: 5
                }
            },

            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            format(percentage) {
                return `${percentage}%`;
            },


            getSumm(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },



            //recherche info projet ou chantier
            submitForm() {
            },
            closeDialog() {
                this.$emit("close");
            },

            createBudget()
            {
                this.loading = true;
                let url = this.domaine+"budgetProjet/create";
                let data = new FormData();
                data.append("tableBudget", JSON.stringify(this.tableBudget));
                data.append("idProjet", this.idProjet);
                data.append("typeTravauxId", this.typeTrx.id);
                data.append("userId", this.user.id);
                this.$http.post(url,data).then(
                    resp =>{
                        this.closeDialog();
                        this.tableBudget.splice(0);
                        this.loading = false;
                        this.$notify({
                            title: "Budget",
                            message: "Budget enregistre avec succes",
                            type: "success",
                            position: "top-right",
                            duration: 7000
                        });
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error(
                            "Erreur lors  de l'enregistrement du budget"
                        );
                    }
                );
            }
        },

        mounted() {
        }
    };
</script>

<style>
    tr td.el-table__expanded-cell {
        background-color:#EEEEEE;
    }



    td.el-table__expanded-cell div {
        background-color:#ffffff;
    }
</style>




// WEBPACK FOOTER //
// src/components/projet/AjoutPrevisionBudget.vue